import { render, staticRenderFns } from "./AdminSchoolsView.vue?vue&type=template&id=751d5534"
import script from "./AdminSchoolsView.vue?vue&type=script&lang=ts"
export * from "./AdminSchoolsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports